<template lang="pug">
.landing-page-root
    .bg-blue.hero-bg
        section.hero(style="padding-bottom: 1.25rem;")

            .title(style='line-height: 1;') #[span.linear-gradient Serverless] #[span.wordset Backend API]
            .desc(style='opacity: 1') Skapi is a serverless backend platform for #[span.wordset web applications] and AI agents.#[br]#[br]Add powerful backend capabilities to #[span.wordset your web applications.]#[br]Setup your AI agents with robust #[span.wordset backend infrastructure.]


            template(v-if="user?.user_id")
                button(type="button" data-aos="fade-up" data-aos-duration="500" data-track="landing_hero_myServices" @click="$router.push('/my-services')") Go to My Services
            router-link(v-else to="/signup" data-track="landing_hero_signUp")
                button(type="button" data-aos="fade-up" data-aos-duration="500") Get Started
        br

        section.video
            .wrap
                video.video-skapi(
                    ref="player"
                    playsinline
                    muted
                    loop
                    preload="metadata"
                )
                    source(src="@/assets/img/landingpage/video_skapi_mp4.mp4" type="video/mp4")
        br
        br
        br
        br

    .bg-dark
        section#section1.feature
            .title(data-aos="fade-up" data-aos-delay="200" style="margin-bottom: 3.75rem;") Why Skapi?
            .feature-wrap(data-aos="fade-up" data-aos-delay="400")
                .feature-item
                    .img
                        img(style='width:150px;height:120px;object-fit: cover;padding-right:15px;' src="@/assets/img/landingpage/feature13.svg", alt="AI Icon")
                    .title Works with Any#[br]AI Assistant
                    .content Design your web application with any AI code generator. Let your AI implement full backend functionality.

                .feature-item
                    .img
                        img(src="@/assets/img/landingpage/feature10.svg", alt="Everything Included Icon" style="height: 120px; width: 100px; object-fit: cover;")
                    .title Everything#[br]Included
                    .content Authentication, database, file storage, real-time data, email services. All with zero configuration or backend code.

                .feature-item
                    .img
                        img(src="@/assets/img/landingpage/feature1.svg", alt="Framework Icons")
                    .title Flexible for#[br]Any Stack
                    .content Integrate with Vue, React, Angular, Next.js, any other JS framework or even plain HTML.

                .feature-item
                    .img
                        img(src="@/assets/img/landingpage/feature4.svg", alt="Global CDN Icon")
                    .title Instant#[br]File Hosting
                    .content Host static websites instantly via a global CDN.

                .feature-item
                    .img
                        img(src="@/assets/img/landingpage/icon_reason2.svg", alt="Lock Icon" style='height: 120px; width: 150px; object-fit: cover;')
                    .title Powerful and#[br]Secure Database
                    .content Client-side integration with end-to-end security keeps your data protected while remaining reliable and accessible across your applications.

                .feature-item
                    .img
                        img(style='width:150px;height:120px;object-fit: cover;padding-right:15px;' src="@/assets/img/landingpage/feature11.svg", alt="Cloud Icon")
                    .title 100%#[br]Serverless
                    .content No servers, no stress. No idle servers running 24/7. Use your backend in a cost-efficient, fully scalable way.
    
    .bg-blue
        section.review
            .title(data-aos="fade-up" data-aos-delay="200") Real Reviews
            .review-swiper(data-aos="fade-up" data-aos-delay="300")
                swiper(
                    :slidesPerView="1"
                    :spaceBetween="30"
                    :initialSlide="randomReviewInitialSlide"
                    :loop="true"
                    :pagination="{ clickable: true }"
                    :navigation="{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }"
                    :autoplay="{ delay: 3000, disableOnInteraction: false }"
                    :modules="[Pagination, Navigation, Autoplay]"
                    @swiper="onSwiperReady"
                )
                    swiper-slide.review-item
                        .reviewer
                            img#reviewerImg(src="@/assets/img/landingpage/reviewer1.svg" alt="Reviewer 1")
                            .profile
                                .name Munid Matan
                                .position Full Stack Developer
                        .content
                            .summary
                                p Skapi is perfect for students, professionals, and local businesses seeking a secure and efficient solution.
                                img(src="@/assets/img/landingpage/stars.svg" alt="Stars")
                            .entire As a student, I struggled with sending data to databases using Apache servers because plugin installation caused frequent OS errors. Skapi solves this by letting you import APIs and send data directly, with no extra plugins needed. It saves time, avoids errors, and requires no backend coding.
                    
                    swiper-slide.review-item
                        .reviewer
                            img(src="@/assets/img/landingpage/reviewer2.svg" alt="Reviewer 2")
                            .profile
                                .name Aae Kim
                                .position Junior Frontend Developer
                        .content
                            .summary
                                p Thanks to Skapi, I can build full applications using only frontend code.
                                img(src="@/assets/img/landingpage/stars.svg", alt="Stars")
                            .entire When I was a junior frontend developer the biggest challenge I faced was not being able to build a complete service on my own, mostly because a backend is essential, and I had no experience. When I discovered Skapi, everything changed. I was able to handle data fetching and all server-side functionality with just a few simple lines of code. Skapi feels like a better alternative to Firebase or Supabase. It’s easy and doesn’t waste days just trying to sync backend logic and data communication.

                    swiper-slide.review-item
                        .reviewer
                            img(src="@/assets/img/landingpage/reviewer3.svg", alt="Reviewer 3")
                            .profile
                                .name Hee Jong Lee
                                .position Full Stack Developer
                        .content
                            .summary
                                p Someone completely new to web development could use Skapi without any prior database knowledge. It requires zero setup.
                                img(src="@/assets/img/landingpage/stars.svg", alt="Stars")
                            .entire I work on core systems and web development at an insurance company. One of the challenges I often face is setting up new environments or getting started with unfamiliar frameworks. Skapi reduces the time I spend installing packages and configuring environments. For database operations, it’s incredibly convenient. You can just start using the database right away, no setup required.
                .swiper-button-prev
                    img(src="@/assets/img/landingpage/arrow_left.svg", alt="Arrow Left")
                .swiper-button-next
                    img(src="@/assets/img/landingpage/arrow_right.svg", alt="Arrow Right")

    .bg-dark
        section#section2.use-cases
            .title(data-aos="fade-up" data-aos-delay="200") Starter Templates
            .desc(data-aos="fade-up" data-aos-delay="200") Ready-to-use templates for HTML, Vue, Angular, and React.
            .use-cases-content(data-aos="fade-up" data-aos-delay="400")
                .link-card-wrap
                    a.link-card.light(href="https://github.com/kkb75281/getting-started-template-vanilla-html" target="_blank" data-track="landing_templates_html")
                        .icon
                            img(src="@/assets/img/logo/icon_html.svg")
                        span.title HTML
                        p.desc A clean and minimal starter template using only HTML, CSS, and JavaScript. Great for beginners, quick prototypes, or when you need a lightweight setup without frameworks.

                    a.link-card.light(href="https://github.com/kkb75281/getting-started-template-vue" target="_blank" data-track="landing_templates_vue")
                        .icon
                            img(src="@/assets/img/logo/icon_vue.svg")
                        span.title Vue.js
                        p.desc A Vue 3 starter template crafted for rapid and efficient development. Showcases best practices for integrating Skapi into your project.

                    a.link-card.light(href="https://github.com/kkb75281/getting-started-template-angular" target="_blank" data-track="landing_templates_angular")
                        .icon
                            img(src="@/assets/img/logo/icon_angular.svg")
                        span.title Angular
                        p.desc A complete Angular starter template with TypeScript support. Showcases best practices for integrating Skapi into your project.

                    a.link-card.light(href="https://github.com/kkb75281/getting-started-template-react" target="_blank" data-track="landing_templates_react")
                        .icon
                            img(src="@/assets/img/logo/icon_react.svg")
                        span.title React
                        p.desc A modern React starter template powered by Vite for blazing-fast builds and hot reload. Showcases best practices for integrating Skapi into your project.

    .bg-blue
        section.use-cases
            .title(data-aos="fade-up" data-aos-delay="200") Use Cases
            .desc(data-aos="fade-up" data-aos-delay="200") Pre-built templates for database, authentication and real-time communication. Explore ready-to-use examples that show how Skapi features work in real applications.
            .use-cases-content(data-aos="fade-up" data-aos-delay="400")
                .link-card-wrap
                    a.link-card(href="https://github.com/kkb75281/skapi-auth-html-template" target="_blank" data-track="landing_useCases_auth")
                        .icon
                            svg
                                use(xlink:href="/material-icon.svg?v=20250829065753667#icon-users")
                        span.title Basic Authentication
                        p.desc A plain HTML starter showcasing Skapi’s authentication system. Includes login, signup, and account management features you can easily integrate.
                                
                    a.link-card(href="https://github.com/kkb75281/skapi-database-html-template" target="_blank" data-track="landing_useCases_database")
                        .icon
                            svg
                                use(xlink:href="/material-icon.svg?v=20250829065753667#icon-database")
                        span.title Data and File Uploads
                        p.desc An HTML example for building a simple photo-sharing app with Skapi’s database. Users can log in, upload photos, and fetch content securely.

                    a.link-card(href="https://github.com/kkb75281/skapi-chat-html-template" target="_blank" data-track="landing_useCases_chat")
                        .icon
                            svg
                                use(xlink:href="/material-icon.svg?v=20250829065753667#icon-chat")
                        span.title Chat Application
                        p.desc A lightweight chat application template using Skapi’s real-time features. Supports login, message posting, and instant updates between users.
                                    
                    a.link-card(href="https://github.com/kkb75281/skapi-webrtc-html-template" target="_blank" data-track="landing_useCases_webrtc")
                        .icon
                            svg
                                use(xlink:href="/material-icon.svg?v=20250829065753667#icon-webrtc")
                        span.title Video Calls
                        p.desc A basic video call app built with Skapi’s WebRTC capabilities. Logged-in users can request, accept, and join live video sessions.
    
    .bg-colorful
        section#section3.plan
            .title.black(data-aos="fade-up" data-aos-delay="200") Pricing Plans
            .desc.black(data-aos="fade-up" data-aos-delay="200") Start for free.#[br]Test features, connect your frontend, #[span.wordset and launch your project.]#[br]Decide later if you want to upgrade.
            PlanCards(
                data-aos="fade-up" data-aos-delay="400"
                :spaceBetween="30"
                :swiperBreakpoints="{ 0: { slidesPerView: 1, enabled: true, loop: true }, 801: { slidesPerView: 2, enabled: false, loop: false } }"
            )
                template(#standardAction)
                    router-link.standard(data-track="landing_plan_standard" :to="user?.user_id ? { path: '/my-services', query: { action: 'create' } } : { path: '/signup', query: { action: 'create' } }")
                        button(type="button") Start Free Trial
                            p Free for the first 30 days
                template(#premiumAction)
                    router-link.premium(data-track="landing_plan_premium" :to="user?.user_id ? { path: '/my-services', query: { action: 'create' } } : { path: '/signup', query: { action: 'create' } }")
                        button(type="button") Start Free Trial
                            p Free for the first 30 days

    .bg-dark
        section#section4.faq
            .title(data-aos="fade-up" data-aos-delay="200") FAQ
            ul.faq-list(data-aos="fade-up" data-aos-delay="400")
                li.faq-item
                    .item-title(:class="{ open: openStates[0]}" @click="faqToggle(0)") Can I create a web application in Skapi?

                    .item-cont(v-show="openStates[0]")
                        p.text Skapi isn’t a full web-app builder, so you won’t create an entire app inside our platform. But we make it easy to build your app with any AI assistant and Skapi as your backend.
                        p.text We’ve got plenty of step-by-step tutorials on YouTube and Dev.to, and if you prefer to dive right in, you can use the ready-made templates in our documentation. We’ll guide you every step of the way.

                li.faq-item
                    .item-title(:class="{ open: openStates[1]}" @click="faqToggle(1)") How does Skapi work?
                    .item-cont(v-show="openStates[1]")
                        p.text Skapi is a backend API  that you can integrate directly from your frontend.
                        p.text Import the JavaScript library in the way that fits your workflow:
                        code
                            pre
                                span &lt;script src="https://cdn.jsdelivr.net/npm/skapi-js@{{npmVersion}}/dist/skapi.js"&gt;&lt;/script&gt;
                        p.text Or install via npm:
                        code
                            pre
                                span npm install skapi-js@{{npmVersion}}
                        p.text Prefer using an AI assistant?
                        p.text Just mention Skapi in your prompt, and it will generate the integration for you automatically.
                        br
                        p.text.line(style="display: inline-block") For detailed instructions, check out our 
                        a(href="https://docs.skapi.com/introduction/getting-started.html" target="_blank") Getting Started


                li.faq-item
                    .item-title(:class="{ open: openStates[2]}" @click="faqToggle(2)") Do I need backend engineering knowledge?
                    .item-cont(v-show="openStates[2]")
                        p.text Not at all. With Skapi, there’s no server to set up, no backend code to write, and no complex configuration required. Just drop it into your frontend, and you’re ready to build.
                        p.text Skapi is also designed for AI-assisted and no-code development. Since everything runs securely from the frontend, you can even let your AI agent build a full-stack app without exposing backend infrastructure.
                        p.text It’s the simplest and safest way to bring automation and AI into modern web development.
                li.faq-item
                    .item-title(:class="{ open: openStates[3]}" @click="faqToggle(3)") My 30-day trial is ending - what happens next?
                    .item-cont(v-show="openStates[3]")
                        p.text No worries! Since we don’t ask for your credit card at sign-up, nothing gets charged automatically. 
                        p.text If you want to keep your service running, just choose a subscription before your trial ends, we’ll remind you ahead of time.
                        p.text If you decide not to subscribe right away, your service will pause and users won’t be able to access it.
                        p.text Your data will still be kept safe for 90 more days, and you can activate a subscription anytime to bring your service back online.

                li.faq-item
                    .item-title(:class="{ open: openStates[4]}" @click="faqToggle(4)") What happens if I cancel my subscription?
                    .item-cont(v-show="openStates[4]")
                        p.text If you cancel your subscription, you’ll still have full access to your service until the end of your billing period.
                        p.text After that, the service will stop responding to requests.
                        p.text Your data will be retained for 90 days after your subscription ends.
                        p.text  If you don’t reactivate within that window, all data will be permanently deleted.

    .bg-blue
        section#section5.contents
            .title(data-aos="fade-up" data-aos-delay="200") Contents
            .tab-cont-wrap
                TabMenu(v-model="activeTabs.contents" :tabs="['Videos', 'Articles']" data-aos="fade-up" data-aos-delay="400")
                .tab-cont(data-aos="fade-up" data-aos-delay="600")
                    .tab-item-wrap(v-show="activeTabs.contents === 0")
                        .tab-item.videos(v-for="video in videos" :key="video.id")
                            .videos-wrap
                                iframe(
                                    :src="`https://www.youtube.com/embed/${video.id}`"
                                    :title="video.title"
                                    allow="encrypted-media"
                                    allowfullscreen
                                    frameborder="0"
                                )
                            .title {{ video.title }}

                    .tab-item-wrap(v-show="activeTabs.contents === 1")
                        .tab-item(v-for="article in articles" :key="article.id")
                            .title {{ article.title }}
                            .desc {{ article.description }}
                            a.btn-read-more(:href="article.url" target="_blank") Read more

    .bg-dark
        section.banner
            .banner-inner
                .title.black(data-aos="fade-up" data-aos-delay="600") Start Building Today!
                .desc.black(data-aos="fade-up" data-aos-delay="600") Serverless Backend for Modern Web Apps and AI agents.
                template(v-if="user?.user_id")
                    button(type="button" data-aos="fade-up" data-aos-delay="800" data-track="landing_banner_myServices" @click="$router.push('/my-services')") Go to My Services
                router-link(v-else to="/signup" data-track="landing_banner_signUp")
                    button(type="button" data-aos="fade-up" data-aos-delay="800") Get Started
</template>

<script setup>
import { onMounted, ref, onUnmounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { user } from "@/code/user";
import { copy } from "@/code/utils";
import TabMenu from "@/components/tab.vue";
import PlanCards from "@/components/planCards.vue";
import { npmVersion } from "@/main";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css"; // import Swiper styles
import "swiper/css/pagination";
import "swiper/css/navigation";

const router = useRouter();
const activeTabs = ref({
    contents: 0,
});
const reviewSlidesCount = 3;
const randomReviewInitialSlide = Math.floor(Math.random() * reviewSlidesCount);
const articles = ref([]);
const videos = ref([
    {
        id: "IW5eTf0Tpts",
        title: "Supabase vs Skapi Real Time Query Performance Test",
    },
    {
        id: "zmuUosk0ohE",
        title: "Build Web Apps Fast with Skapi – Zero Setup Serverless Backend",
    },
]);
const videosLoaded = ref(false); // 비디오 데이터 로드 여부
const player = ref(null);

function setSwiperImageWidth() {
    let swiperImage = document.getElementById("reviewerImg");
    if (!swiperImage) return; // null 체크 추가

    let swiperImageWidth = swiperImage.getBoundingClientRect().height + 18;

    document.body.style.setProperty(
        "--swiper-pagination-translate-y",
        `${swiperImageWidth}px`
    );
}

function onSwiperReady(swiper) {
    setTimeout(() => {
        setSwiperImageWidth();
    }, 100); // 약간의 딜레이로 DOM이 완전히 렌더링되도록 함
}

// 각 FAQ 항목 toggle (하나 열리면 다른 항목은 닫힘)
const openStates = ref([false, false]);
function faqToggle(index) {
    if (openStates.value[index]) {
        openStates.value[index] = false; // 이미 열려있으면 닫음
        return;
    }

    // 다른 항목은 닫음
    for (let i = 0; i < openStates.value.length; i++) {
        openStates.value[i] = false;
    }

    openStates.value[index] = true; // 선택한 항목만 열림
}

// 스크롤에 따른 영상 효과
function handleScroll() {
    const videoWrap = document.querySelector(".video .wrap");
    if (!videoWrap || !player.value) return;

    const maxScroll = 100;
    const scrollTop = Math.min(window.scrollY, maxScroll);
    const progress = scrollTop / maxScroll;

    // 회전 효과 적용
    const rotate = 15 - 15 * progress;
    videoWrap.style.transform = `perspective(1000px) rotateX(${rotate}deg)`;

    // 스크롤이 최상단이면 비디오 정지
    if (window.scrollY < 50) {
        player.value.pause();
        return;
    }

    // 비디오 위치 기반으로 재생/정지 제어
    const rect = videoWrap.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // 조건: 영상의 절반 이상이 화면 안에 들어오면 재생, 아니면 정지
    const visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
    const isHalfVisible = visibleHeight > rect.height / 2;

    if (isHalfVisible) {
        player.value.play().catch(() => {
            // 자동 재생 실패 시 무시
        });
    } else {
        player.value.pause();
    }
}

// contents > videos (youtube api 호출 - Videos 탭 클릭 시에만 API 호출)
// const fetchVideos = async () => {
//     if (videosLoaded.value) return; // 이미 로드된 경우 중복 호출 방지

//     videosLoaded.value = true;

//     const CHANNEL_ID = "UC0e4MITESMr3OaUiyWHpdYA"; // Skapi 공식 유튜브 채널 ID
//     const API_KEY = import.meta.env.VITE_API_KEY;

//     try {
//         // 최신 영상 검색
//         const searchRes = await fetch(
//             `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet&order=date&maxResults=10&type=video`
//         );
//         const searchData = await searchRes.json();
//         const videoIds = searchData.items
//             .map((item) => item.id.videoId)
//             .join(",");

//         // 영상 상세 조회 (duration 얻기)
//         const videosRes = await fetch(
//             `https://www.googleapis.com/youtube/v3/videos?key=${API_KEY}&id=${videoIds}&part=snippet,contentDetails`
//         );
//         const videosData = await videosRes.json();

//         // shorts 제외 (60초 이하 제외) 후 3개만 선택
//         const filtered = videosData.items
//             .filter((item) => {
//                 const duration = item.contentDetails.duration;
//                 const match = duration.match(/PT((\d+)M)?(\d+)S/);
//                 let totalSeconds = 0;
//                 if (match) {
//                     const minutes = match[2] ? parseInt(match[2], 10) : 0;
//                     const seconds = match[3] ? parseInt(match[3], 10) : 0;
//                     totalSeconds = minutes * 60 + seconds;
//                 }
//                 return totalSeconds > 60;
//             })
//             .slice(0, 3)
//             .map((item) => ({
//                 id: item.id,
//                 title: item.snippet.title,
//                 description: item.snippet.description,
//             }));

//         videos.value = filtered;
//         videosLoaded.value = true;
//     } catch (error) {
//         videos.value = []; // 에러 발생 시 빈 배열로 초기화
//     }
// };

onMounted(async () => {
    window.addEventListener("resize", setSwiperImageWidth);
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    const heroArea = document.querySelector(".hero");
    if (heroArea) {
        requestAnimationFrame(() => {
            heroArea.classList.add("active");
        });
    }

    // contents > articles (Dev.to api 호출)
    try {
        const response = await fetch(
            "https://dev.to/api/articles?username=skapi_api&per_page=3"
        );
        if (!response.ok) throw new Error("Fetch failed");

        // Content-Type 체크로 JSON 여부 확인
        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
            throw new Error("Response is not JSON");
        }

        articles.value = await response.json();
    } catch (err) {
        articles.value = []; // 에러 발생 시 빈 배열로 초기화
    }
});

onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll, { passive: true });
});

onUnmounted(() => {
    window.removeEventListener("resize", setSwiperImageWidth);
    window.removeEventListener("scroll", handleScroll, { passive: true });

    const heroArea = document.querySelector(".hero");
    if (heroArea) {
        heroArea.classList.remove("active");
    }
});
</script>

<style lang="less" scoped>
::v-deep(.plan-swiper-wrap) {
    .swiper-wrapper {
        flex-wrap: wrap;
        justify-content: center;
        gap: 30px 0;
    }

    .swiper-pagination-bullet {
        color: #000;
        border: 1px solid #000;
        flex-basis: 100px;
        padding: 0.625rem 0;
        font-size: 20px;

        &.on {
            background-color: #000;
            color: #fff;

            &:hover {
                background-color: #000;
            }
        }
    }
}

section {
    margin: 0 2.5rem;
    color: #fff;
    text-align: center;

    .title {
        font-size: 3rem;
        margin-bottom: 20px;

        &.black {
            font-weight: 500;
            color: #000;
        }
    }

    .desc {
        font-weight: 300;
        font-size: 1.25rem;
        opacity: 0.7;

        &.black {
            font-weight: 400;
            color: #000;
        }
    }
}

.bg-blue {
    background-color: #16171a;
}

.bg-dark-blue {
    background-color: #121214;
}

.bg-dark {
    background-color: #111112;
}

.bg-colorful {
    background: url("@/assets/img/landingpage/bg_colorful.svg") lightgray 50% / cover no-repeat;
}

.hero-bg {
    position: relative;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 56.25rem;
        background-color: #121214;
    }
}

.hero {
    position: relative;
    padding-top: 8.125rem;
    padding-bottom: 4.25rem;
    z-index: 1;
    opacity: 0;
    transition: opacity 1s ease, transform 1s ease;

    &.active {
        opacity: 1;
    }

    .title {
        font-size: 4rem;
        font-weight: 500;
        margin-bottom: 1.25rem;
    }

    .desc {
        max-width: 47rem;
        margin: 0 auto;
        line-height: 1.5;
        margin-bottom: 1.875rem;
    }

    .linear-gradient {
        background-image: linear-gradient(92.16deg,
                #0156ff 3.64%,
                #079af2 37.09%,
                #49c48d 61.65%,
                #e0fa1c 100%);
        background-clip: text;
        -webkit-background-clip: text;
        color: transparent;
    }
}

.video {
    position: relative;
    margin: 0;
    padding: 0 2.5rem;
    z-index: 1;
    overflow: hidden;
    height: auto;

    .wrap {
        max-width: 1200px;
        margin: 0 auto;
        border-radius: 0.625rem;
        overflow: hidden;
        border: 1px solid rgba(255, 255, 255, 0.1);
        // max-height: 46.875rem;
        // height: 39.1vw;
        aspect-ratio: 560 / 350;

        perspective: 1000px;
        transform-style: preserve-3d;
        transform: perspective(1000px) rotateX(15deg);
        transition: transform 0.1s linear;
        will-change: transform;
    }

    .video-skapi {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.why {
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;

    .title {
        margin-bottom: 3.75rem;
    }

    .reason-wrap {
        display: flex;
        align-items: center;
        max-width: 1440px;
        margin: 0 auto;
        gap: 1.875rem;

        .reason-item {
            max-width: 33%;
            flex-grow: 1;

            .title {
                font-size: 1.75rem;
                font-weight: 400;
                line-height: 1.2;
                margin-bottom: 0.875rem;
            }

            .desc {
                font-size: 1.125rem;
                line-height: 1.5;
            }
        }
    }
}

.review {
    padding: 3.75rem 0 5rem 0;

    .title {
        margin-bottom: 5rem;
    }

    .review-swiper {
        position: relative;
        max-width: 1450px;
        margin: 0 auto;
        padding: 0 8vw;

        .swiper-button-prev,
        .swiper-button-next {
            position: absolute;
            top: 50%;
            transform: translateY(-130%);

            &::after {
                display: none;
            }

            margin-top: unset;
            background-color: transparent;
            background-size: cover;
            width: 72px;
            height: 72px;
            background-color: #191a1f;
            border-radius: 50%;
            opacity: 1;
            user-select: none;

            &:hover {
                background-color: #25252a;
            }
        }

        .swiper-button-prev {
            left: 0;
        }

        .swiper-button-next {
            right: 0;
        }
    }

    .review-item {
        display: flex;
        gap: 60px;
        align-items: stretch;
        width: 100%;
        max-width: 1400px;
        margin: 0 auto;

        .reviewer {
            position: relative;
            flex: 1 0 25%;
            height: 620px;
            border-radius: 0.8125rem;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }

            .profile {
                position: absolute;
                bottom: 2.25rem;
                left: 2.25rem;
                font-size: 1.25rem;
                line-height: 1.5;
                text-align: left;

                .name {
                    font-weight: 500;
                }

                .position {
                    font-weight: 300;
                    opacity: 0.7;
                }
            }
        }

        .content {
            flex: 1 0 30%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            text-align: left;

            .summary {
                p {
                    margin: 0;
                    font-size: 2.125rem;
                    line-height: 1.3;
                    margin-bottom: 1.25rem;
                }
            }

            .entire {
                font-size: 1.25rem;
                font-weight: 300;
                line-height: 1.5;
                opacity: 0.7;
            }
        }
    }
}

.feature {
    padding: 5rem 0;

    .desc {
        line-height: 1.4;
        margin-bottom: 5rem;
    }

    .feature-wrap {
        max-width: 1580px;
        margin: 0 auto;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 2.5rem;

        .feature-item {
            position: relative;
            display: flex;
            flex-direction: column;
            // justify-content: space-between;
            padding: 50px;
            gap: 50px;
            text-align: left;
            // background: #121214;

            background: #16171a;
            border-radius: 17px;
            box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.05);

            &:nth-child(1) {
                .img {
                    right: 0px;
                }
            }

            &:nth-child(2) {
                .img {
                    right: 50px;
                }
            }

            // &:nth-child(5),
            // &:nth-child(6) {
            //     .img {
            //         right: 0px;
            //     }
            // }

            &:nth-child(3) {
                .img {
                    right: 20px;
                }
            }

            &:nth-child(4) {
                .img {
                    right: -10px;
                }
            }

            .img {
                position: absolute;
                top: 30px;
                right: 30px;
            }

            .title {
                position: relative;
                margin: 0;
                font-size: 2rem;
                line-height: 1.2;
                z-index: 1;
                // height: 4.875rem;
            }

            .content {
                opacity: 0.7;
                font-size: 1.0625rem;
                line-height: 1.3;
            }
        }
    }
}

.use-cases {
    padding: 5rem 0;

    .desc {
        max-width: 36rem;
        margin: 0 auto;
        line-height: 1.4;
        margin-bottom: 5rem;
    }

    .use-cases-content {
        max-width: 1580px;
        margin: 0 auto;
        text-align: center;

        .link-card-wrap {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
        }

        .link-card {
            position: relative;
            width: 23%;
            min-width: 250px;
            flex-grow: 1;
            background-color: #121214;
            border-radius: 1.0625rem;
            padding: 1.5rem;
            overflow: hidden;
            color: #fff;
            text-align: left;
            transition: all 0.3s ease;
            scale: 0.98;
            display: flex;
            flex-direction: column;

            &:hover {
                text-decoration: none;
                scale: 1;
            }

            &.light {
                background-color: #16171a;
            }
        }

        .title {
            font-size: 1rem;
            margin: 0;
        }

        .icon {
            height: 8rem;
            border-bottom: 1px solid rgba(255, 255, 255, 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.5rem 0.5rem 0 0;
            transition: all 0.3s ease;
            // opacity: 0.5;

            svg {
                width: 32px;
                height: 32px;
            }
        }

        .title {
            display: inline-block;
            margin-top: 1rem;
        }

        .desc {
            margin: 1rem 0 0;
            font-size: 14px;
            line-height: 1.5;
            color: rgba(255, 255, 255, 0.5);
            flex: 1;
        }
    }
}

.promo-banner {
    padding: 5rem 0 6rem;

    .title {
        background-image: linear-gradient(92.16deg,
                #0156ff 3.64%,
                #079af2 37.09%,
                #49c48d 51.65%,
                #e0fa1c 80%);
        background-clip: text;
        -webkit-background-clip: text;
        color: transparent;
        font-size: 3.125rem;
        font-weight: 500;
        line-height: 1.4;
        margin-bottom: 0.625rem;
    }

    .desc {
        line-height: 1.4;
        margin-bottom: 1.875rem;
        color: rgba(255, 255, 255, 0.7);

        .wordset {
            display: block;
        }
    }
}

.plan {
    padding: 5rem 0 6.25rem 0;

    .desc {
        margin-bottom: 1.875rem;
    }

    .plan-swiper-wrap {
        .plan-item {
            border: unset;
        }
    }
}

.faq {
    padding: 5rem 0 5.625rem;

    .title {
        font-weight: 400;
        margin-bottom: 3.125rem;
    }

    .faq-list {
        padding: 0;
        margin: 0 auto;
        list-style: none;
        max-width: 62.5rem;
    }

    .faq-item {
        background-color: #16171a;
        border-radius: 0.875rem;
        margin-bottom: 1rem;
        text-align: left;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .item-title {
        font-size: 1.375rem;
        font-weight: 500;
        line-height: 1.4;
        padding: 1.875rem 6.125rem 1.875rem 2.5rem;
        position: relative;
        cursor: pointer;

        &::after {
            content: "";
            width: 2rem;
            height: 2rem;
            background: url(/src/assets/img/landingpage/icon_plus.svg) no-repeat;
            background-size: cover;
            position: absolute;
            right: 2.5rem;
            top: 1.8rem;
            transition: transform 0.5s ease;
            transform-origin: center;
        }

        &.open {
            &::after {
                transform: rotate(45deg);
            }
        }
    }

    .item-cont {
        padding: 0.25rem 4.5rem 2.5rem 2.75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.2;

        ul {
            padding-left: 1.5rem;

            li {
                line-height: 1.3;
            }
        }
    }

    .text {
        margin: 0;
        word-break: keep-all;
        opacity: 0.7;

        &.line {
            display: inline-block;
        }

        &+a {
            margin-left: 0.375rem;
        }
    }
}

.contents {
    padding: 4.375rem 0;

    .title {
        margin-bottom: 2.25rem;
    }

    .tab-cont-wrap {
        max-width: 63.75rem;
        margin: 0 auto;
    }

    :deep(.tab-menu) {
        margin-bottom: 3.125rem;

        ul {
            box-shadow: none;
            gap: 0.625rem;
            padding: 0;
            border-radius: 0;
            background-color: transparent;

            li {
                padding: 0.75rem 1.875rem;
                border: 1px solid #fff;
                border-radius: 2.5rem;
                font-size: 1.25rem;
                font-weight: 500;
                color: #fff;

                &.active {
                    background-color: #fff;
                    color: #000;
                }
            }
        }

        .active-menu {
            display: none;
        }
    }

    .tab-item-wrap {
        display: flex;
        align-items: flex-start;
        gap: 1.875rem;
        flex-wrap: wrap;
    }

    .tab-item {
        padding: 2.25rem 2.5rem;
        border-radius: 1rem;
        flex: 1;
        text-align: left;
        min-height: 26.25rem;
        display: flex;
        flex-direction: column;
        border-radius: 1rem;
        background: url("@/assets/img/landingpage/bg_contents1.svg") lightgray 50% / cover no-repeat;
        color: #000;

        &:nth-child(2) {
            background-image: url("@/assets/img/landingpage/bg_contents2.svg");
        }

        &:nth-child(3) {
            background-image: url("@/assets/img/landingpage/bg_contents3.svg");
        }

        .title {
            font-size: 1.5rem;
            font-weight: 500;
            line-height: 1.3;
            margin-bottom: 1.25rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
        }

        .desc {
            font-size: 1rem;
            font-weight: 500;
            line-height: 1.3;
            margin-bottom: 3rem;
        }

        .btn-read-more {
            margin-top: auto;
            max-width: fit-content;
            padding: 0.875rem 1.375rem;
            border-radius: 2.5rem;
            border: 1px solid #000;
            background: transparent;
            font-size: 1.125rem;
            font-weight: 500;
            color: #000;

            &:hover {
                text-decoration: none;
                background-color: rgba(255, 255, 255, 0.05);
            }
        }

        &.videos {
            background: none;
            padding: 0;
            color: #fff;
            min-height: fit-content;

            .videos-wrap {
                border-radius: 1rem;
                overflow: hidden;

                position: relative;
                width: 100%;

                &::before {
                    content: "";
                    display: block;
                    padding-bottom: 56.25%;
                }
            }

            iframe {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
                background: #eee;

                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .title {
                font-size: 1.25rem;
                line-height: 1.5;
                margin-bottom: 0;
                margin-top: 1rem;
            }
        }
    }
}

.banner {
    padding: 7.5rem 0;
    margin: 0 5rem;

    .banner-inner {
        max-width: 1600px;
        margin: 0 auto 0;

        .title {
            background-image: linear-gradient(92.16deg,
                    #0156ff 3.64%,
                    #079af2 37.09%,
                    #49c48d 51.65%,
                    #e0fa1c 80%);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            font-size: 3.125rem;
            font-weight: 500;
            line-height: 1.4;
            margin-bottom: 0.625rem;
        }

        .desc {
            line-height: 1.4;
            margin-bottom: 1.875rem;
            color: rgba(255, 255, 255, 0.7);

            .wordset {
                display: block;
            }
        }
    }
}

.btn {
    padding: 0.875rem 4.375rem;
    background-color: #0a4df1;
    border-radius: 0.875rem;
    display: inline-block;
    font-size: 1.125rem;
    font-weight: 500;
    color: #fff;

    &:hover {
        text-decoration: none;
        background-color: #1656f2;
    }
}

@media (min-width: 1400px) {
    .feature {
        .feature-wrap {
            grid-template-columns: repeat(3, 1fr);
        }
    }
}

@media (max-width: 1280px) {
    .review {
        .review-swiper {
            padding: 0;

            .swiper-button-prev,
            .swiper-button-next {
                left: 50%;
                bottom: 0 !important;
                top: unset;
                right: unset;
            }

            .swiper-button-prev {
                transform: translate(calc(-50% - 42px), 0);
            }

            .swiper-button-next {
                transform: translate(calc(-50% + 42px), 0);
            }
        }
    }

    .banner {
        padding-top: 80px;
    }
}

@media (max-width: 1000px) {
    .feature {
        .feature-wrap {
            max-width: 600px;
            margin: 0 auto;
            grid-template-columns: repeat(1, 1fr);

            .feature-item {
                .title {
                    height: initial;
                }
            }
        }
    }
}

@media (max-width: 900px) {
    .contents {
        .tab-item-wrap {
            flex-direction: column;
            gap: 1.375rem;
        }

        .tab-item {
            min-height: 18.375rem;
            width: 100%;

            &.videos {
                min-height: fit-content;
                margin-bottom: 1.75rem;
            }
        }
    }
}

@media (max-width: 800px) {
    ::v-deep(.plan-swiper-wrap) {
        .swiper-wrapper {
            flex-wrap: unset;
            justify-content: unset;
            gap: unset;
        }
    }

    .hero {
        padding-bottom: 5rem;

        .title {
            margin-bottom: 0.875rem;
        }
    }

    .why {
        .reason-wrap {
            flex-direction: column;
            gap: 2.5rem;

            .reason-item {
                max-width: unset;
                display: flex;
                align-items: center;
                text-align: left;
            }
        }
    }

    .review {
        .review-item {
            flex-direction: column;

            .content {
                text-align: center;

                .summary {
                    img {
                        margin-bottom: 2.5rem;
                    }
                }
            }
        }
    }

    .banner {
        margin: 0 3.75rem;

        .banner-inner {
            .title {
                font-size: 2.875rem;
            }

            .desc {
                font-size: 1.125rem;
            }
        }
    }
}

@media (max-width: 600px) {
    .why {
        .reason-wrap {
            .reason-item {
                flex-wrap: wrap;
                text-align: center;

                .image {
                    margin: 0 auto;
                }
            }
        }
    }

    .banner {
        .banner-inner {
            .desc {
                .wordset {
                    display: unset;
                }
            }
        }
    }
}

@media (max-width: 540px) {
    .feature {
        .feature-wrap {
            grid-gap: 2.25rem;

            .feature-item {
                text-align: center;
                justify-content: flex-start;
                gap: 30px;

                .img {
                    position: relative;
                    height: 130px;
                    top: unset !important;
                    right: unset !important;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        padding: 0 !important;
                    }
                }

                &:nth-child(1) {
                    .img {
                        padding-left: 16px;
                    }
                }

                &:nth-child(6) {
                    .img {
                        // padding-left: 30px;
                    }
                }

                &:nth-child(5) {
                    .img {
                        padding-left: 8px;
                    }
                }

                // &:nth-child(2) {
                //     .img {
                //         padding-right: 16px;
                //     }
                // }

                &:nth-child(3) {
                    .img {
                        padding-right: 16px;
                    }
                }

                &:nth-child(4) {
                    .img {
                        padding-left: 16px;
                    }
                }
            }
        }
    }

    .faq {
        padding: 3.125rem 0 3.75rem;

        .title {
            margin-bottom: 1.875rem;
        }

        .item-title {
            padding: 1rem 4rem 1rem 1.5rem;
            font-size: 1rem;

            &::after {
                width: 1.625rem;
                height: 1.625rem;
                right: 1.625rem;
                top: 1rem;
            }
        }

        .item-cont {
            padding: 0.25rem 1.5rem 1.875rem;
            font-size: 0.875rem;
        }
    }

    .contents {
        .tab-item {
            .btn-read-more {
                font-size: 0.9375rem;
                padding: 0.625rem 1rem;
            }
        }
    }
}

@media (max-width: 480px) {
    .review {
        .review-swiper {

            .swiper-button-prev,
            .swiper-button-next {
                display: none;
            }
        }
    }
}

@media (max-width: 430px) {
    .btn {
        font-size: 1rem;
        padding: 0.875rem;
        width: 14.375rem;
        max-width: 100%;
    }

    section {
        margin: 0 1.875rem;

        .title {
            font-size: 1.875rem;
            margin-bottom: 1rem;
        }

        .desc {
            font-size: 0.875rem;
        }
    }

    .hero-bg {
        &::before {
            height: 43rem;
        }
    }

    .hero {
        padding-top: 5rem;
        padding-bottom: 3.75rem;

        .title {
            font-size: 2.625rem;
            margin-bottom: 0.875rem;
        }

        .desc {
            // padding: 0 1.25rem;
            // margin-bottom: 2.5rem;
            font-size: 0.9375rem;
        }
    }

    .video {
        padding: 0 1.875rem;
    }

    .why {
        padding-top: 5rem;
        padding-bottom: 5rem;

        .title {
            margin-bottom: 2.5rem;
        }

        .reason-wrap {
            gap: 3.125rem;

            .reason-item {
                .image {
                    img {
                        width: 12rem;
                        height: 12rem;
                    }
                }

                .title {
                    font-size: 1.5625rem;
                    margin-bottom: 0.75rem;
                }

                .desc {
                    font-size: 0.9375rem;
                }
            }
        }
    }

    .review {
        padding: 3.125rem 0 2.5rem 0;

        .title {
            margin-bottom: 2.5rem;
        }

        .review-swiper {

            .swiper-button-prev,
            .swiper-button-next {
                width: 56px;
                height: 56px;
            }

            .swiper-button-prev {
                transform: translate(calc(-50% - 32px), 0);
            }

            .swiper-button-next {
                transform: translate(calc(-50% + 32px), 0);
            }
        }

        .review-item {
            .reviewer {
                position: relative;
                width: 100%;
                height: 0;
                padding-bottom: 117.65%;
                overflow: hidden;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                }

                .profile {
                    left: 24px;
                    bottom: 24px;
                    font-size: 0.9375rem;

                    .name {
                        margin-bottom: 4px;
                    }
                }
            }

            .content {
                .summary {
                    p {
                        font-size: 1.625rem;
                    }
                }

                .entire {
                    font-size: 0.875rem;
                }
            }
        }
    }

    .feature {
        padding: 3.125rem 0;

        .title {
            margin-bottom: 1rem;
        }

        .desc {
            margin-bottom: 2.5rem;
        }

        .feature-wrap {
            display: block;

            .feature-item {
                gap: 6vw;
                padding: 11.5vw;
                margin-bottom: 1.5rem;

                &:last-child {
                    margin-bottom: 0;
                }

                .img {
                    img {
                        width: 46vw;
                    }
                }

                .title {
                    font-size: 1.625rem;
                }

                .content {
                    font-size: 0.875rem;
                }
            }
        }
    }

    .use-cases {
        padding: 3.125rem 0;

        .title {
            margin-bottom: 1rem;
        }

        .desc {
            margin-bottom: 2.5rem;
        }

        .use-cases-content {
            .link-card {
                min-width: 100%;
            }
        }
    }

    .plan {
        .title {
            margin-bottom: 1rem;
        }

        .desc {
            margin-bottom: 1.25rem;
        }
    }

    .faq {
        .title {
            margin-bottom: 1.875rem;
        }
    }

    .contents {
        padding: 3.75rem 0 2.5rem;

        .title {
            margin-bottom: 1.875rem;
        }

        :deep(.tab-menu) {
            ul {
                gap: 0.375rem;

                li {
                    padding: 0.625rem 1rem;
                    font-size: 0.9375rem;
                }
            }
        }

        .tab-item {
            min-height: 23.75rem;

            .title {
                font-size: 1.75rem;
            }

            .desc {
                font-size: 0.875rem;
                margin-bottom: 2rem;
            }
        }
    }

    .banner {
        padding: 3.75rem 0 5rem 0;
        margin: 0 1.875rem;

        .banner-inner {
            padding: 18.5vw 9.5vw;

            .title {
                font-size: 1.75rem;
            }

            .desc {
                max-width: 240px;
                font-size: 0.9375rem;
                margin: 0 auto;
                margin-bottom: 1.25rem;
            }

            button {
                width: 100%;
            }
        }
    }

    .promo-banner {
        padding: 3.75rem 0 5rem 0;

        .title {
            font-size: 1.75rem;
        }

        .desc {
            max-width: 240px;
            font-size: 0.9375rem;
            margin: 0 auto;
            margin-bottom: 1.25rem;
        }

        button {
            width: 100%;
        }
    }
}

@media (max-width: 300px) {
    .hero {
        .title {
            font-size: clamp(30px, 14vw, 2.625rem);
        }
    }
}
</style>
